import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import Logo from "../Assets/BooksCompl.png";
import "./Auth.css";

const SignUp = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [message, setMessage] = useState({ content: "", type: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, password, confirmPassword } = formData;

    if (!agreeToTerms) {
      setMessage({ content: "You must agree to the terms and conditions", type: "danger" });
      return;
    }

    if (password !== confirmPassword) {
      setMessage({ content: "Passwords do not match", type: "danger" });
      return;
    }

    if (password.length < 6) {
      setMessage({ content: "Password must be at least 6 characters", type: "danger" });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Registration failed");
      }

      setMessage({
        content: data.message || "Registration successful! Please check your email to verify your account.",
        type: "success"
      });

      setFormData({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
      });

    } catch (error) {
      setMessage({
        content: error.message || "An error occurred during registration",
        type: "danger"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid signup-container fade-in">
      <div className="main-logo">
        <img src={Logo} alt="Logo" className="logo-img" />
      </div>
      <div className="row justify-content-center align-items-center vh-100">
        <div className="col-lg-6 col-md-8 col-sm-10 signup-card p-4">
          <div className="row">
            <div className="col-md-12">
              <h2 className="text-center mb-4">Create Account</h2>

              {message.content && (
                <div className={`alert alert-${message.type}`} role="alert">
                  {message.content}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3 position-relative">
                  <FaUser className="input-icon" />
                  <input
                    type="text"
                    name="name"
                    className="form-control signup-input"
                    placeholder="Full Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group mb-3 position-relative">
                  <FaEnvelope className="input-icon" />
                  <input
                    type="email"
                    name="email"
                    className="form-control signup-input"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group mb-3 position-relative">
                  <FaLock className="input-icon" />
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="form-control signup-input"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleInputChange}
                    required
                  />
                  <span
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                <div className="form-group mb-3 position-relative">
                  <FaLock className="input-icon" />
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    className="form-control signup-input"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    required
                  />
                  <span
                    className="password-toggle"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

                <div className="form-group mb-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="agreeToTerms"
                      checked={agreeToTerms}
                      onChange={(e) => setAgreeToTerms(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="agreeToTerms">
                      By signing up, you agree to the {" "}
                      <a
                        href={process.env.REACT_APP_PRIVACY_POLICY_URL}
                        className="text-primary"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}
                      >
                        Privacy Notice
                      </a>
                      {" "} and {" "}
                      <a
                        href={process.env.REACT_APP_SUBSCRIPTION_AGREEMENT_URL}
                        className="text-primary"
                        target="_blank"
                        style={{ textDecoration: "none" }}
                      >
                        Subscription Agreement
                      </a>
                    </label>
                  </div>
                </div>

                <button
                  className="btn btn-primary w-100"
                  type="submit"
                  disabled={loading || !agreeToTerms}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Creating Account...
                    </>
                  ) : "Create Account"}
                </button>
              </form>

              <div className="text-center mt-3">
                Already have an account?{" "}
                <a href="/login" className="signup-link">
                  Login
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SignUp;